import React from 'react';
import cn from 'classnames';
import { graphql, useStaticQuery } from 'gatsby';
import { IPalominaSettings } from '@palomina/palomina-sanity';
import { SVG } from '@palomina/palomina-common/components';

import * as styles from './styles.module.scss';

const ContactCard = () => {
  const siteSettings: IPalominaSettings = useStaticQuery(graphql`
    query {
      sanityPalominaSettings {
        contactEmail
        socials {
          _key
          platform
          url {
            url
          }
        }
      }
    }
  `)?.sanityPalominaSettings;

  const { contactEmail, socials } = siteSettings || {};

  return (
    <main className={styles.container}>
      <div className={styles.card}>
        <figure className={styles.wordmark}>
          <SVG svg="wordmark" />
        </figure>

        {contactEmail && <p className="b1">Contact</p>}

        {contactEmail && (
          <a
            className={cn('b1', styles.contactButton)}
            href={`mailto:${contactEmail}`}
          >
            {contactEmail}
          </a>
        )}

        {socials?.[0] && (
          <div className={styles.socials}>
            {socials.map(({ _key, platform, url }) => {
              return (
                <a
                  className={styles.socialLink}
                  key={`contact-social-link-${_key}`}
                  target="_blank"
                  rel="noreferrer"
                  href={url.url}
                >
                  <SVG svg={platform} />
                </a>
              );
            })}
          </div>
        )}
      </div>
    </main>
  );
};

export default ContactCard;
